<template>
  <div>
    <print-preview @reset="reset" :landscape="landscape">
      <div slot="pages">
        <template>
          <page
            :styles="styles"
            :title="tableData.title"
            :sub_title="tableData.sub_title"
            :subheading="tableData.subheading"
            :brnch_name="tableData.brnch_name"
            :second_sub_title="tableData.second_sub_title"
          >
            <template slot="header">
              <th colspan="100%" class="pt-2"></th>
              <tr class="pb-2 secondary white--text font-weight-bold">
                <td v-if="!hideRowNo">{{ $t("number") }}</td>
                <td
                  v-for="(item, i) in headers"
                  :key="'c_' + i"
                  :class="item.class"
                >
                  <strong>{{ item.text }}</strong>
                </td>
              </tr>
            </template>
            <template slot="body">
              <tr v-for="(item, index) in items" :key="'a_' + index">
                <td v-if="!hideRowNo">{{ index + 1 }}</td>
                <template v-for="(i, c) in headers">
                  <td
                    :key="'d_' + c"
                    :colspan="item.colspan"
                    :class="item.class + ' ' + i.item_class"
                  >
                    <strong>{{ getObjectValueByPath(item, i) }}</strong>
                  </td>
                </template>
              </tr>
              <tr
                v-for="(item, index) in footers"
                :key="'tf_' + index"
                v-html="item"
              ></tr>

              <!-- <html-component v-html="footer"></html-component> -->
            </template>
          </page>
        </template>
      </div>
    </print-preview>
  </div>
</template>

<script>
import get from "lodash/get";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("ReportsModule", { tableData: "tableData" }),
    hideRowNo(){
      return this.tableData.hideRowNo
    },
    items() {
      return this.tableData.items;
    },
    headers() {
      return this.tableData.headers;
    },
    landscape() {
      return this.tableData.landscape;
    },
    footers() {
      return this.tableData.footers;
    },
    styles() {
      if (this.landscape) return { "min-height": "200mm", width: "290mm" };
      return { "min-height": "297mm", width: "200mm" };
    },
  },

  methods: {
    getObjectValueByPath(obj, filed) {
      if (filed.computed) return filed.computed(obj);
      let value = get(obj, filed.value, "");
      if (filed.filter) return filed.filter(obj);
      return value;
    },

    reset() {
      this.$store.commit("ReportsModule/setTableData", {
        title: "",
        items: [],
        headers: [],
        subheading: "",
      });
      this.$router.back();
    },
  },
};
</script>
<style>
.flexFifty {
  width: 50%;
  display: flex;
}

.flexRow {
  display: flex;
  justify-content: space-between;
}

.persianTitle {
  /* font-family: "IR_M"; */
  font-size: 12px;
  text-align: right;
}

.englishTitle {
  /* font-family: "IR_M"; */
  font-size: 12px;
  text-align: left;
}

.middleTitle {
  flex: 1;
  font-size: 12px;
  text-align: center;
}
</style>